import { render, staticRenderFns } from "./auth-redirect.vue?vue&type=template&id=6c0a6231&scoped=true"
import script from "./auth-redirect.vue?vue&type=script&lang=js"
export * from "./auth-redirect.vue?vue&type=script&lang=js"
import style0 from "./auth-redirect.vue?vue&type=style&index=0&id=6c0a6231&lang=scss"
import style1 from "./auth-redirect.vue?vue&type=style&index=1&id=6c0a6231&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a6231",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c0a6231')) {
      api.createRecord('6c0a6231', component.options)
    } else {
      api.reload('6c0a6231', component.options)
    }
    module.hot.accept("./auth-redirect.vue?vue&type=template&id=6c0a6231&scoped=true", function () {
      api.rerender('6c0a6231', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/common/login/auth-redirect.vue"
export default component.exports